/**
 * Base module that exposes means to make API calls and low-level config.
 * For example, the Proxy would configure HTTP/S calls, i.e. add a Bearer header.
 *
 * @module Proxy
 * @version 1.0.0
 */
import http, { AxiosStatic } from 'axios';
// import { dataLinkLocalBackEndUrl } from './config';

interface IProxy {
  http: AxiosStatic;
  endpoints: { apiUrl: string };
  init: (url: string) => void;
}

const endpoints: { apiUrl: string } = { apiUrl: '' };

const init = (url: string) => {
  endpoints.apiUrl = url;
  /* if (process.env.NODE_ENV === 'development') {
    endpoints.apiUrl = dataLinkLocalBackEndUrl;
  } */
};

http.interceptors.request.use(
  async config => {
    if (config && config.headers) {
      if (!config.headers['api-version']) {
        config.headers['api-version'] = 1;
      }
    }
    return config;
  },
  error => Promise.reject(error)
);

const self: IProxy = {
  /**
   * Exposes HTTP methods equivalent to REST verbs (GET, POST, UPDATE, PUT, DELETE, etc.).
   * > Currently based on axios, see {@link https://github.com/axios/axios github.com/axios} for more information.
   *
   * ```
   * http.get('<url>');
   * http.post('<url>', { <body> });
   * ```
   */
  http,
  endpoints,
  init,
};

export default self;
